export enum AttractionIconMode {
  Sign = 'Sign',
  Map = 'Map',
  Pin = 'Pin',
}
